import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ProgressBar from "../ProgressBar";
import "../../css/main-card.css";

const MainCard = ({
  dinosImage,
  backImage,
  groundImage,
  title,
  link,
  players,
  maxPlayers,
  serverName,
  className,
}) => {
  // const cardRef = useRef(null);

  // function hideOverflow() {
  //   setTimeout(() => {
  //     if (cardRef) cardRef.current.style.overflow = "hidden";
  //   }, 400);
  // }

  // function showOverflow() {
  //   if (cardRef) cardRef.current.style.overflow = "";
  // }

  // useEffect(() => {
  //   if (cardRef) {
  //     const curr = cardRef.current;
  //     curr.addEventListener("mouseleave", hideOverflow);
  //     curr.addEventListener("mouseenter", showOverflow);

  //     return () => {
  //       curr.removeEventListener("mouseleave", hideOverflow);
  //       curr.removeEventListener("mouseenter", showOverflow);
  //     };
  //   }
  // }, [cardRef]);

  return (
    <div className={`main-card ${className ? className : ""}`}>
      <div className="main-card-container">
        {backImage && (
          <LazyLoadImage
            src={backImage}
            alt=""
            className="main-card-image back-image"
          />
        )}
        <div className="main-card-content">
          <div className="title text-outlined">{title}</div>
          <div className="players">
            <ProgressBar withLogo={true} value={players} max={maxPlayers} />
            <div className="server-name">{serverName}</div>
          </div>
        </div>
      </div>
      <LazyLoadImage
        src={groundImage}
        alt=""
        className="main-card-image ground-image"
      />
      <LazyLoadImage
        src={dinosImage}
        alt=""
        className="main-card-image dinos-image"
      />
    </div>
  );
};

export default MainCard;
